import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Delivery } from './components/Delivery';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Faq } from './components/Faq';
import { FinalChoice } from './components/FinalChoice';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full bg-ink" data-id="element-0" data-mp="28t4ju9krg2qw">
      <MetaPixel data-id="element-1" data-mp="28s2zfehuu3wi" />
      <Hero data-id="element-2" data-mp="23vkv2fqfs7kp" />
      <main data-id="element-3" data-mp="23vulg4fe8gqx">
        <BeforeAfter data-id="element-4" data-mp="23u9uspw79hyc" />
        <PainPoints data-id="element-5" data-mp="23ut97wmn5o7m" />
        <Volumes data-id="element-6" data-mp="23ti8k5ohswkq" />
        <Delivery data-id="element-7" data-mp="3ik7gihlkcdr6" />
        <Bonuses data-id="element-8" data-mp="3ikr0s4yore8d" />
        <Offer data-id="element-9" data-mp="3ij64a9st9l7v" />
        <Guarantee data-id="element-10" data-mp="3ijpbowku4r7n" />
        <Testimonials data-id="element-11" data-mp="3ii4sg33z0up3" />
        <About data-id="element-12" data-mp="3mlaxj7fckftz" />
        <Faq data-id="element-13" data-mp="3mkrc3gqhn9b7" />
        <FinalChoice data-id="element-14" data-mp="3mk8710lxsfel" />
      </main>
      <Footer data-id="element-15" data-mp="3mjg8pi0yg3km" />
      <FloatingCTA data-id="element-16" data-mp="3rc9d24sih9w6" />
      <PurchasePopup data-id="element-17" data-mp="3rbrbqtqzs5he" />
    </div>;
}